import { render, staticRenderFns } from "./InspectionShipmentDetailEdit.vue?vue&type=template&id=728d77d5"
import script from "./InspectionShipmentDetailEdit.vue?vue&type=script&lang=js"
export * from "./InspectionShipmentDetailEdit.vue?vue&type=script&lang=js"
import style0 from "./InspectionShipmentDetailEdit.vue?vue&type=style&index=0&id=728d77d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports